import React, { Fragment } from "react";
import { useHistory } from "react-router-dom";
import { FormContainer, MediumTextBlue, SmallTextBlue } from "./login.styles";
import SubmitButton from "./submit-button";

const RegPass = () => {
  const history = useHistory(); // Get the navigate function
  const changeUrl = () => {
    history.push("/");
  };

  return (
    <Fragment>
      <FormContainer>
        <div className='p-fluid'>
          <div className='k-text-center k-my-20px'>
            <MediumTextBlue>Your account is ready to use. </MediumTextBlue>
          </div>
          <div className='k-text-center k-my-20px'>
            <MediumTextBlue>You can now login</MediumTextBlue>
          </div>
          <div className='k-text-center k-my-40px'>
            <SubmitButton
              buttonText={"Go to the Login Page"}
              loading={false}
              handleSubmit={changeUrl}
            />
          </div>
        </div>
      </FormContainer>
    </Fragment>
  );
};

export default RegPass;
